<div class="card" *ngIf="field?.fieldGroup?.length">
  <div class="d-flex-row">
    <h3 class="card-header">{{ props?.label }}</h3><mat-icon [matTooltip]="props?.tooltip" matTooltipPosition="right">info_outline</mat-icon>
  </div>
  <ng-container #fieldComponent></ng-container>
</div>
